import majorSponsors from './7A-majorSponsors.js';
import scrollerSponsors from './7B-scrollerSponsors.js';

export default function sponsorsFeature() {
  majorSponsors();
  scrollerSponsors();
}
